export { default as ProjectsV1 } from './ProjectsV1';
export { default as HomeProjectCard, ctaLabelForProject } from './HomeProjectCard';
export type { HomeProjectEntry, HomeProjectImage } from './HomeProjectCard';
